// API wrappers for the Hot Topics submenu under Brands. Thin shims over the
// shared fetch helpers in src/api/index.js, targeting /api/hot-topics.
import { get, post, remove } from "../index";

const BASE = "/api/hot-topics";

function qs(params = {}) {
  const parts = [];
  for (const k in params) {
    if (params[k] === undefined || params[k] === null || params[k] === "") continue;
    parts.push(`${k}=${encodeURIComponent(params[k])}`);
  }
  return parts.length ? `?${parts.join("&")}` : "";
}

export const listHotTopics = (params) => get(`${BASE}${qs(params)}`);
export const analyzeHotTopics = (brand_id) => post(`${BASE}/analyze`, { brand_id }, false);
export const assignHotTopic = (id) => post(`${BASE}/${id}/assign`, {}, false);
export const deleteHotTopic = (id) => remove(`${BASE}/${id}`);
